import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { fetchSsoConfig, initMsal } from "./auth";
import AppShell from "./AppShell";
import { initTheme } from "./theme";

initTheme();

const dummyMsal = new PublicClientApplication({
  auth: { clientId: "dummy", authority: "https://login.microsoftonline.com/common" },
});

async function bootstrap() {
  let msalInstance: PublicClientApplication = dummyMsal;
  let ssoEnabled = false;

  try {
    const config = await fetchSsoConfig();
    if (config.endUserOauth.enabled && config.endUserOauth.clientId && config.endUserOauth.tenantId) {
      msalInstance = await initMsal(config.endUserOauth.clientId, config.endUserOauth.tenantId);
      await msalInstance.handleRedirectPromise();
      ssoEnabled = true;
    }
  } catch {
    // SSO config fetch failed — fall back to API key only
  }

  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <AppShell ssoEnabled={ssoEnabled} />
        </MsalProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

bootstrap();
